import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom'; // Adicione o useLocation aqui

import logo from "./img/LogoBrancoCPP.png";
import styles from "./Header.module.css";
import HeaderNav from "../../Components/HeaderNav";
import DropdownServicos from "../../Components/DropDownServices";

function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    
    // Captura a URL atual em que o usuário está
    const location = useLocation();

    // Sempre que a variável 'location' mudar, este useEffect roda e fecha tudo
    useEffect(() => {
        setIsMenuOpen(false);
        setIsDropdownOpen(false); // Aproveitamos para garantir que o dropdown também feche
    }, [location]);

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    
    return (
        <header className={styles.header}>
            <Link to="/">
                <img src={logo} alt="Logo do CPP" className={styles.logo}/>
            </Link>

            <button className={styles.mobileMenuBtn} onClick={toggleMenu} aria-label="Menu">
                {isMenuOpen ? '✖' : '☰'}
            </button>

            <nav className={`${styles.nav} ${isMenuOpen ? styles.navOpen : ''}`}>
                
                {/* Passamos o isDropdownOpen para desativar os outros links */}
                <HeaderNav url="/" disableActive={isDropdownOpen}>Home</HeaderNav>
                
                {/* Passamos o controle do estado para o componente do dropdown */}
                <DropdownServicos isOpen={isDropdownOpen} setIsOpen={setIsDropdownOpen} />
                
                {/* Passamos o isDropdownOpen para desativar os outros links */}
                <HeaderNav url="/sobre" disableActive={isDropdownOpen}>Sobre</HeaderNav>
                <HeaderNav url="/contato" disableActive={isDropdownOpen}>Contato</HeaderNav>
                <HeaderNav url="/blog" disableActive={isDropdownOpen}>Blog</HeaderNav>
            </nav>
        </header>
    );
}

export default Header;